/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Current_PlanInputs */

const es_components_upgrade_plan_modal_current_plan = /** @type {(inputs: Components_Upgrade_Plan_Modal_Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan Actual`)
};

const en_components_upgrade_plan_modal_current_plan = /** @type {(inputs: Components_Upgrade_Plan_Modal_Current_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Plan`)
};

/**
* | output |
* | --- |
* | "Current Plan" |
*
* @param {Components_Upgrade_Plan_Modal_Current_PlanInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_current_plan = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Current_PlanInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Current_PlanInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_current_plan(inputs)
	return en_components_upgrade_plan_modal_current_plan(inputs)
});
export { components_upgrade_plan_modal_current_plan as "components.upgrade_plan_modal.current_plan" }